import React, { useEffect, useState } from 'react'

import { firestore } from '../../firebase';

import './LoanCalculator.css'

function LoanCalculator() {

    const [renter, setRenter] = useState([]);
    const [amount, setAmount] = useState(3000000);
    const [years, setYears] = useState(25);
    const [rente, setRente] = useState();

    const [annuitet, setAnnuitet] = useState(null);

    useEffect(() => {

        try {
            const renteRef = firestore.collection("renter");
            renteRef.orderBy("bank").onSnapshot(({docs}) => {
                const renter = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setRenter(renter);
            })
        } catch (error) {
            
        }

    }, [])

    function loanCalculator(rente, years, amount) {

        let annuitet;
        const i = rente/100/12;
        let pow = 1+i;
        const n = years*12;

        pow = Math.pow(pow, -n);
        annuitet = i/(1-pow)*amount;

        console.log(i, pow, n)

        return annuitet;
    }

    function submitHandler(e) {
        e.preventDefault();
        try {
            
            const annuitet = loanCalculator(rente, years, amount);
            const annuitetFormatted = annuitet.toFixed(0);
            setAnnuitet(annuitetFormatted);

        } catch (error) {
            
        }
    }

    return (
        <form onSubmit={submitHandler}>

            {annuitet && <h2 className="text-center my-4">{annuitet} kr ({rente}% rente)</h2>}

            <div className="form-group">
                <label>Lånebeløp: {amount} kr</label>
                <div className="slideContainer">
                    <input type="range" className="slider" value={amount} max="15000000" step="30000" onChange={e => setAmount(e.target.value)} />
                </div> 
            </div>
            <div className="form-group">
                <label>År nedbetaling: {years} år</label>
                <div className="slideContainer">
                    <input type="range" className="slider" value={years} max="30" onChange={e => setYears(e.target.value)} />
                </div>
                
            </div>
            <div className="form-group">
                <select className="browser-default custom-select" onChange={e => setRente(e.target.value)}>
                    <option>Velg bank</option>
                    {renter?.map((bank, index) => {
                        return <option key={index} value={bank.rente}>{bank.bank} ({bank.rente_type})</option>
                    })}
                </select>
            </div>

            <button className="btn btn-success btn-block">Beregn</button>
        </form>
    )
}
export default LoanCalculator